<template>
<section>
<div class="container col-xl-10 col-xxl-8 px-4 py-5">
    <div class="row align-items-center g-lg-5 py-5">
        <div class="col-lg-7 text-center text-lg-start">
            <h3 class="display-6 fw-bold lh-1 mb-3 text-primary">购买指南</h3>
            <p class="col-lg-10 fs-6 text-left">三鱼公司御燕牌燕窝分别在三家大统华超市上柜销售。请认准御燕牌商标。</p>
            <p class="col-lg-10 fs-6 text-left">批发用户请联系: 778-951-9997</p>
            <p class="col-lg-10 fs-6 text-left">线上商城正在筹备中，请稍后查询</p>
        </div>
        <div class="col-md-10 mx-auto col-lg-5">
            <img src="@/assets/order.jpg" width="100%" />
        </div>
    </div>
</div>
<div class="container px-4 py-5 pt-0" id="hanging-icons">
    <h2 class="pb-2 border-bottom">零售商城地址</h2>
    <div class="row g-4 py-5 row-cols-1 row-cols-lg-3">
      <div class="col d-flex align-items-start">
        <div class="icon-square bg-light text-dark flex-shrink-0 me-3">
          <van-icon name="location-o" size="30"/>
        </div>
        <div>
          <h4 class="text-left">Metrotown 大统华</h4>
          <p>147-4800 Kingsway, Burnaby, BC V5H 4J2</p>
        </div>
      </div>
      <div class="col d-flex align-items-start">
        <div class="icon-square bg-light text-dark flex-shrink-0 me-3">
          <van-icon name="location-o" size="30"/>
        </div>
        <div>
          <h4 class="text-left">Lansdowne 大统华</h4>
          <p>8311 Lansdowne Rd, Richmond, BC V6X 3A4</p>
          
        </div>
      </div>
      <div class="col d-flex align-items-start">
        <div class="icon-square bg-light text-dark flex-shrink-0 me-3">
          <van-icon name="location-o" size="30"/>
        </div>
        <div>
          <h4 class="text-left">Osaka 大统华</h4>
          <p>Yaohan Center , 1000, 3700 No. 3 Rd, Richmond, BC V6X 3X2</p>
          
        </div>
      </div>
    </div>
  </div>

  </section>
</template>
<script>
  import { onMounted } from 'vue'
  //import $ from 'jquery'
  export default {
    name: 'Shopping',
    components: {},
    emits: ['viewLoaded'],
    setup(props,ctx) {
      
        onMounted(() =>{
            console.log('Shopping mounted')
            ctx.emit('viewLoaded','shopping')
            
        })

        return {
        }
    }
  };
</script>
<style lang="scss" scoped>
 p {text-align: left !important;}
 h4 {text-align: left;}
</style>